
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4851"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4851"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $6d4cdddf4124503a$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["c7Ica","index.8a390506.js","9GH72","datapath.29ce0ff5.png","6YhTM","datapath_hazards.62eaf9d5.png"]'));

// interface IFormatInstruction {
//     type: "I",
//     rs: number,
//     rt: number,
//     immediate: number,
// }
// interface RFormatInstruction {
//     type: "R",
//     rs: number,
//     rt: number,
//     rd: number,
// }
// type Instruction = IFormatInstruction | RFormatInstruction;
const $650a6a6350d8bfea$var$registerNames = [
    "zero",
    "at",
    "v0",
    "v1",
    "a0",
    "a1",
    "a2",
    "a3",
    "t0",
    "t1",
    "t2",
    "t3",
    "t4",
    "t5",
    "t6",
    "t7",
    "s0",
    "s1",
    "s2",
    "s3",
    "s4",
    "s5",
    "s6",
    "s7",
    "t8",
    "t9",
    "k0",
    "k1",
    "gp",
    "sp",
    "fp",
    "ra"
];
function $650a6a6350d8bfea$var$registerToNumber(rawRegister) {
    for(let i = 0; i < $650a6a6350d8bfea$var$registerNames.length; i++){
        if (rawRegister.toLowerCase().startsWith($650a6a6350d8bfea$var$registerNames[i])) return i;
    }
    return parseInt(rawRegister);
}
function $650a6a6350d8bfea$export$bd7f5dfb6f55c221(text_instructions) {
    let instructionList = [];
    for (let line of text_instructions){
        let splitLine = line.split("$");
        let registerCount = splitLine.length - 1;
        let instruction;
        switch(registerCount){
            case 2:
                if (splitLine[0] === "sw ") instruction = {
                    raw_instruction: line,
                    inputRegisters: [
                        $650a6a6350d8bfea$var$registerToNumber(splitLine[1]),
                        $650a6a6350d8bfea$var$registerToNumber(splitLine[2])
                    ],
                    outputRegister: null
                };
                else instruction = {
                    raw_instruction: line,
                    inputRegisters: [
                        $650a6a6350d8bfea$var$registerToNumber(splitLine[2])
                    ],
                    outputRegister: $650a6a6350d8bfea$var$registerToNumber(splitLine[1]) // rt
                };
                break;
            case 3:
                instruction = {
                    raw_instruction: line,
                    inputRegisters: [
                        $650a6a6350d8bfea$var$registerToNumber(splitLine[2]),
                        $650a6a6350d8bfea$var$registerToNumber(splitLine[3])
                    ],
                    outputRegister: $650a6a6350d8bfea$var$registerToNumber(splitLine[1]) // rd
                };
                break;
            default:
                throw new Error(`Instruction "${line}" invalid.`);
        }
        instructionList.push(instruction);
    }
    return instructionList;
}


var $2ef2be5e1191d5ff$exports = {};
$2ef2be5e1191d5ff$exports = new URL("datapath.29ce0ff5.png", import.meta.url).toString();


var $cfcc0086c5cb1872$exports = {};
$cfcc0086c5cb1872$exports = new URL("datapath_hazards.62eaf9d5.png", import.meta.url).toString();


const $0f592d681121713f$var$instructionInput = document.getElementById("instructions");
const $0f592d681121713f$var$loadInstructionsButton = document.getElementById("load-instructions-btn");
const $0f592d681121713f$var$runSingleClockCycleButton = document.getElementById("run-single-clock-cycle-btn");
const $0f592d681121713f$var$toggleViewButton = document.getElementById("toggle-view-btn");
const $0f592d681121713f$var$toggleForwardingButton = document.getElementById("toggle-forwarding-btn");
const $0f592d681121713f$var$forwardingStatus = document.getElementById("forwarding-status");
const $0f592d681121713f$var$diagramBody = document.getElementById("diagram-body");
const $0f592d681121713f$var$diagramCountHeader = document.getElementById("diagram-count");
const $0f592d681121713f$var$diagramHeaderDefault = document.getElementById("diagram-header-default-template");
const $0f592d681121713f$var$pipelineContainer = document.getElementById("pipeline-container");
const $0f592d681121713f$var$diagramContainer = document.getElementById("diagram-container");
const $0f592d681121713f$var$datapathImage = document.getElementById("datapath-image");
const $0f592d681121713f$var$fetchStage = document.getElementById("fetch-stage");
const $0f592d681121713f$var$decodeStage = document.getElementById("decode-stage");
const $0f592d681121713f$var$executeStage = document.getElementById("execute-stage");
const $0f592d681121713f$var$memoryStage = document.getElementById("memory-stage");
const $0f592d681121713f$var$writebackStage = document.getElementById("writeback-stage");
$0f592d681121713f$var$loadInstructionsButton?.addEventListener("click", $0f592d681121713f$var$loadInstructions);
$0f592d681121713f$var$runSingleClockCycleButton?.addEventListener("click", ()=>{
    $0f592d681121713f$var$runSingleClockCycle();
    $0f592d681121713f$var$updateDisplay();
});
$0f592d681121713f$var$toggleViewButton?.addEventListener("click", ()=>{
    if ($0f592d681121713f$var$pipelineContainer?.classList.contains("hidden")) {
        $0f592d681121713f$var$pipelineContainer?.classList.remove("hidden");
        $0f592d681121713f$var$diagramContainer?.classList.add("hidden");
    } else {
        $0f592d681121713f$var$pipelineContainer?.classList.add("hidden");
        $0f592d681121713f$var$diagramContainer?.classList.remove("hidden");
    }
});
$0f592d681121713f$var$toggleForwardingButton?.addEventListener("click", ()=>{
    $0f592d681121713f$var$forwardingEnabled = !$0f592d681121713f$var$forwardingEnabled;
    $0f592d681121713f$var$forwardingStatus.innerText = $0f592d681121713f$var$forwardingEnabled ? "On" : "Off";
    if ($0f592d681121713f$var$forwardingEnabled) {
        $0f592d681121713f$var$datapathImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($cfcc0086c5cb1872$exports)));
        $0f592d681121713f$var$fetchStage.style.left = "0%";
        $0f592d681121713f$var$fetchStage.style.width = "16.3%";
        $0f592d681121713f$var$decodeStage.style.left = "18.55%";
        $0f592d681121713f$var$decodeStage.style.width = "26.6%";
        $0f592d681121713f$var$executeStage.style.left = "47.4%";
        $0f592d681121713f$var$executeStage.style.width = "18.3%";
        $0f592d681121713f$var$memoryStage.style.left = "67.9%";
        $0f592d681121713f$var$memoryStage.style.width = "11.3%";
        $0f592d681121713f$var$writebackStage.style.left = "81.5%";
        $0f592d681121713f$var$writebackStage.style.width = "18.5%";
    } else {
        $0f592d681121713f$var$datapathImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($2ef2be5e1191d5ff$exports)));
        $0f592d681121713f$var$fetchStage.style.left = "0%";
        $0f592d681121713f$var$fetchStage.style.width = "23.7%";
        $0f592d681121713f$var$decodeStage.style.left = "26.7%";
        $0f592d681121713f$var$decodeStage.style.width = "16%";
        $0f592d681121713f$var$executeStage.style.left = "45.7%";
        $0f592d681121713f$var$executeStage.style.width = "13.8%";
        $0f592d681121713f$var$memoryStage.style.left = "62.6%";
        $0f592d681121713f$var$memoryStage.style.width = "15.1%";
        $0f592d681121713f$var$writebackStage.style.left = "80.75%";
        $0f592d681121713f$var$writebackStage.style.width = "19.25%";
    }
});
let $0f592d681121713f$var$hazardCount = new Array(32).fill(0);
let $0f592d681121713f$var$instructionList = [];
let $0f592d681121713f$var$dataPathState = new Array(5).fill(null);
const $0f592d681121713f$var$stageLabelMap = [
    "F",
    "D",
    "X",
    "M",
    "W"
];
let $0f592d681121713f$var$instructionsProcessed = 0;
let $0f592d681121713f$var$cycleCount = 0;
let $0f592d681121713f$var$forwardingEnabled = false;
function $0f592d681121713f$var$loadInstructions() {
    try {
        let splitInputList = $0f592d681121713f$var$instructionInput.value.toLowerCase().split("\n").map((el)=>el.trim()).filter((el)=>el !== "");
        let parsedInstructionList = (0, $650a6a6350d8bfea$export$bd7f5dfb6f55c221)(splitInputList);
        $0f592d681121713f$var$instructionList = parsedInstructionList;
        $0f592d681121713f$var$hazardCount = new Array(32).fill(0);
        $0f592d681121713f$var$dataPathState = new Array(5).fill(null);
        $0f592d681121713f$var$instructionsProcessed = 0;
        $0f592d681121713f$var$cycleCount = 0;
        $0f592d681121713f$var$initializePipeline();
        $0f592d681121713f$var$initializeDiagram();
        alert("Program loaded!");
    } catch (err) {
        alert(err);
        console.error(err);
    }
}
function $0f592d681121713f$var$initializePipeline() {
    for(let i = 0; i < $0f592d681121713f$var$dataPathState.length; i++){
        document.getElementById(`${i}-text`).innerText = "";
        document.getElementById(`${i}-text`).style.color = "unset";
        document.getElementById(`${i}-highlight`).style.backgroundColor = "unset";
    }
}
function $0f592d681121713f$var$initializeDiagram() {
    $0f592d681121713f$var$diagramCountHeader.innerHTML = "";
    for (let child of $0f592d681121713f$var$diagramHeaderDefault.content.children)$0f592d681121713f$var$diagramCountHeader.appendChild(child.cloneNode(true));
    $0f592d681121713f$var$diagramBody.innerHTML = "";
    for(let i = 0; i < $0f592d681121713f$var$instructionList.length; i++){
        let parent = document.createElement("tr");
        // parent.id = `${i}-row`;
        let instructionText = document.createElement("th");
        instructionText.innerText = $0f592d681121713f$var$instructionList[i].raw_instruction;
        parent.appendChild(instructionText);
        $0f592d681121713f$var$diagramBody?.appendChild(parent);
    }
}
const $0f592d681121713f$var$NOP = {
    raw_instruction: "NOP",
    inputRegisters: [],
    outputRegister: null
};
function $0f592d681121713f$var$runSingleClockCycle() {
    let registerToFree = $0f592d681121713f$var$dataPathState[4]?.instruction.outputRegister;
    if ($0f592d681121713f$var$dataPathState[4] !== null && $0f592d681121713f$var$dataPathState[4].instruction !== $0f592d681121713f$var$NOP) $0f592d681121713f$var$instructionsProcessed++;
    // Clear Writeback Hazard
    if (!$0f592d681121713f$var$forwardingEnabled && Number.isInteger($0f592d681121713f$var$dataPathState[4]?.instruction.outputRegister)) $0f592d681121713f$var$hazardCount[$0f592d681121713f$var$dataPathState[4]?.instruction.outputRegister] -= 1;
    // Memory -> Writeback
    if ($0f592d681121713f$var$forwardingEnabled && Number.isInteger($0f592d681121713f$var$dataPathState[3]?.instruction.outputRegister)) $0f592d681121713f$var$hazardCount[$0f592d681121713f$var$dataPathState[3]?.instruction.outputRegister] -= 1;
    $0f592d681121713f$var$dataPathState[4] = $0f592d681121713f$var$dataPathState[3];
    // Execute -> Memory
    $0f592d681121713f$var$dataPathState[3] = $0f592d681121713f$var$dataPathState[2];
    if ($0f592d681121713f$var$dataPathState[1] !== null) {
        let includesInputHazards = $0f592d681121713f$var$dataPathState[1].instruction.inputRegisters.reduce((prev, el)=>prev || $0f592d681121713f$var$hazardCount[el] > 0, false);
        if (includesInputHazards) $0f592d681121713f$var$dataPathState[2] = {
            instruction: $0f592d681121713f$var$NOP,
            color: null
        };
        else {
            if ($0f592d681121713f$var$forwardingEnabled) {
                if ($0f592d681121713f$var$dataPathState[1].instruction.raw_instruction.startsWith("lw ")) $0f592d681121713f$var$hazardCount[$0f592d681121713f$var$dataPathState[1].instruction.outputRegister] += 1;
            } else if ($0f592d681121713f$var$dataPathState[1].instruction.outputRegister) $0f592d681121713f$var$hazardCount[$0f592d681121713f$var$dataPathState[1].instruction.outputRegister] += 1;
            $0f592d681121713f$var$dataPathState[2] = $0f592d681121713f$var$dataPathState[1];
            $0f592d681121713f$var$dataPathState[1] = $0f592d681121713f$var$dataPathState[0];
            $0f592d681121713f$var$dataPathState[0] = $0f592d681121713f$var$instructionList.length > 0 ? {
                instruction: $0f592d681121713f$var$instructionList.shift(),
                color: $0f592d681121713f$var$getColor()
            } : null;
        }
    } else {
        $0f592d681121713f$var$dataPathState[2] = $0f592d681121713f$var$dataPathState[1];
        $0f592d681121713f$var$dataPathState[1] = $0f592d681121713f$var$dataPathState[0];
        $0f592d681121713f$var$dataPathState[0] = $0f592d681121713f$var$instructionList.length > 0 ? {
            instruction: $0f592d681121713f$var$instructionList.shift(),
            color: $0f592d681121713f$var$getColor()
        } : null;
    }
    // if (!forwardingEnabled && Number.isInteger(registerToFree)) {
    //     hazardCount[registerToFree as number] -= 1;
    // }
    if ($0f592d681121713f$var$dataPathState.filter((el)=>el !== null).length > 0) {
        $0f592d681121713f$var$cycleCount++;
        console.log($0f592d681121713f$var$cycleCount);
    } else alert("Running complete");
}
let $0f592d681121713f$var$availableColors = [
    "red",
    "blue",
    "green",
    "orange",
    "purple"
];
let $0f592d681121713f$var$colorIndex = -1;
function $0f592d681121713f$var$getColor() {
    $0f592d681121713f$var$colorIndex = ($0f592d681121713f$var$colorIndex + 1) % $0f592d681121713f$var$availableColors.length;
    return $0f592d681121713f$var$availableColors[$0f592d681121713f$var$colorIndex];
}
function $0f592d681121713f$var$updateDisplay() {
    // Update colors on datapath
    for(let i = 0; i < $0f592d681121713f$var$dataPathState.length; i++){
        const state = $0f592d681121713f$var$dataPathState[i];
        const color = state?.color || "unset";
        const text = state?.instruction.raw_instruction || "";
        document.getElementById(`${i}-text`).innerText = text;
        document.getElementById(`${i}-text`).style.color = color;
        document.getElementById(`${i}-highlight`).style.backgroundColor = color;
    }
    if ($0f592d681121713f$var$diagramCountHeader.children.length - 2 < $0f592d681121713f$var$cycleCount) {
        let nextCount = document.createElement("th");
        nextCount.className = "w-12";
        nextCount.innerText = $0f592d681121713f$var$cycleCount.toString();
        console.log($0f592d681121713f$var$diagramCountHeader.lastChild);
        $0f592d681121713f$var$diagramCountHeader.insertBefore(nextCount, $0f592d681121713f$var$diagramCountHeader.children[$0f592d681121713f$var$diagramCountHeader.children.length - 1]);
    }
    // Update Pipeline Diagram
    for(let i = 0; i < $0f592d681121713f$var$diagramBody.children.length; i++){
        let cell = document.createElement("td");
        $0f592d681121713f$var$diagramBody.children[i].appendChild(cell);
    }
    let offset = $0f592d681121713f$var$instructionsProcessed;
    for(let i = $0f592d681121713f$var$dataPathState.length - 1; i >= 0; i--)if ($0f592d681121713f$var$dataPathState[i] !== null && $0f592d681121713f$var$dataPathState[i]?.instruction !== $0f592d681121713f$var$NOP) {
        let cell = $0f592d681121713f$var$diagramBody.children[offset].lastChild;
        cell.innerText = $0f592d681121713f$var$stageLabelMap[i];
        offset++;
    }
}


//# sourceMappingURL=index.8a390506.js.map
